import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfIntroductoryLayoutComponent } from './conf-layout/conf-introductory-layout/conf-introductory-layout.component';
import { ConfConfiguratorLayoutComponent } from './conf-layout/conf-configurator-layout/conf-configurator-layout.component';
import { ConfPredictiveLayoutComponent } from './conf-layout/conf-predictive-layout/conf-predictive-layout.component';
import { ConfError404Component } from './conf-layout/conf-error404/conf-error404.component';
import { AuthGuard } from '../shared/services/auth/auth.guard';

const routes: Routes = [
  {
    path: '', component: ConfIntroductoryLayoutComponent
  },
  {
    path: 'configurator-home', component: ConfIntroductoryLayoutComponent
  },
  {
    path: 'intro/:lob', component: ConfIntroductoryLayoutComponent,canActivate:[AuthGuard],
  },
  // {
  //   path: 'intro/:lob', component: ConfIntroductoryLayoutComponent,
  // },
  {
    path: 'configurator',
    component: ConfConfiguratorLayoutComponent,
    children: [
      {
        path: 'hcv',
        loadChildren: () => import('./Conf-LOB/conf-hcv/conf-hcv.module').then(m => m.ConfHcvModule)
      },
      {
        path: 'bus',
        loadChildren: () => import('./Conf-LOB/conf-bus/conf-bus.module').then(m => m.ConfBusModule)
      },
      {
        path: 'scv',
        loadChildren: () => import('./Conf-LOB/conf-scv-cargo/conf-scv-cargo.module').then(m => m.ConfScvCargoModule)
      },
      {
        path: 'ilmcv',
        loadChildren: () => import('./Conf-LOB/conf-ilmcv/conf-ilmcv.module').then(m => m.ConfIlmcvModule)
      },
      {
        path: 'winger',
        loadChildren: () => import('./Conf-LOB/conf-winger/conf-winger.module').then(m => m.ConfWingerModule)
      },
      {
        path: 'magic',
        loadChildren: () => import('./Conf-LOB/conf-magic/conf-magic.module').then(m => m.ConfMagicModule)
      },
      { path: '**', component: ConfError404Component },
      { path: 'configurator-not-found', component: ConfError404Component }
    ]
  },
  {
    canActivate:[AuthGuard],
    path: 'osp-configurator/:confid', component: ConfConfiguratorLayoutComponent
  },
  {
    path: 'fleetverse-predictive/:lob/:vcno', component: ConfPredictiveLayoutComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfiguratorAppRoutingModule { }